import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";

export const handlePayment = async (inputHandle) => {
  const functions = getFunctions(getApp());
  const createPayment = httpsCallable(functions, "createPayment");

  try {
    const result = await createPayment({
      description: "Queen Center Appointment",
      redirectUrl:
        "https://queencenter.nl/afspraak/3?oi=" +
        btoa(inputHandle.invoiceNumber),
      cancelUrl:
        "https://queencenter.nl/afspraak/3?oi=" +
        btoa(inputHandle.invoiceNumber),
      invoiceNumber: inputHandle.invoiceNumber,
      webhookUrl:
        "https://us-central1-queen-center.cloudfunctions.net/mollieWebhook"
    });

    window.open(result.data.paymentUrl, "_self");
  } catch (error) {
    console.error("Payment error:", error.message);
  }
};
